import React from 'react';
import classNames from 'classnames';
import styles from './UpgradePromptPill.less';
import { Icon, IconName } from 'app/common/components/controls';

/**
 * UpgradePromptPillProps props
 * isDarkTheme: For dark theme
 * cta: call to action of prompt, navigates user within the page
 * ctaLink: link for call to action
 * ctaTrackEvent: function expected to fire a trackUe event, fired on click of cta
 */
interface UpgradePromptPillProps {
  isDarkTheme?: boolean;
  cta: string;
  ctaLink: string;
  ctaTrackEvent?: () => void;
  iconName: IconName;
}

export const UpgradePromptPill = (props: UpgradePromptPillProps) => {
  const { isDarkTheme, cta, ctaLink, ctaTrackEvent, iconName } = props;

  const onClickCTA = (eventContext: object) => {
    if (ctaTrackEvent) {
      ctaTrackEvent();
    }
  };

  const upgradePromptPillClasses = classNames(
    'upgrade-prompt-pill',
    styles.upgradePromptPill,
    (isDarkTheme && styles.upgradeDarkTheme) || styles.upgradeLightTheme,
    isDarkTheme && 'upgrade-prompt-pill-dark',
  );

  return (
    <a href={ctaLink} className={upgradePromptPillClasses} onClick={onClickCTA}>
      <Icon name={iconName} className={styles.upgradePromptPillIcon} small />
      <div className={styles.upgradePromptPillCTA}>{cta}</div>
    </a>
  );
};
